import m from "../../geodata/es2015/bermudaLow";
window.am4geodata_bermudaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bermudaLow.js
// module id = null
// module chunks = 